<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <div>
        <h5 class="info-text">Empecemos con la información básica</h5>
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="firstName"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>face</md-icon>
                <label>Primer Nombre</label>
                <md-input v-model="model.firstName" type="text"> </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-field>
              <md-icon>face</md-icon>
              <label>Segundo Nombre</label>
              <md-input v-model="model.secondName" type="text"> </md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="firstLastName"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>face</md-icon>
                <label>Primer Apellido</label>
                <md-input v-model="model.firstLastName" type="text"> </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>

          <div class="md-layout-item md-size-50 md-small-size-100">
            <ValidationProvider
              name="secondLastName"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <md-field
                :class="[
                  { 'md-error': failed },
                  { 'md-valid': passed },
                  { 'md-form-group': true }
                ]"
              >
                <md-icon>face</md-icon>
                <label>Segundo Apellido</label>
                <md-input v-model="model.secondLastName" type="text">
                </md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="failed">close</md-icon>
                </slide-y-down-transition>
                <slide-y-down-transition>
                  <md-icon class="success" v-show="passed">done</md-icon>
                </slide-y-down-transition>
              </md-field>
            </ValidationProvider>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-card>
              <md-card-header class="md-card-header-icon md-card-header-blue">
                <div class="card-icon">
                  <md-icon>today</md-icon>
                </div>
                <h4 class="title">Fecha de nacimiento</h4>
              </md-card-header>
              <md-card-content>
                <md-datepicker
                  :md-disabled-dates="disabledDates"
                  v-model="model.birthDate"
                />
              </md-card-content>
            </md-card>
          </div>
          <ApolloQuery
            :query="require('../../../graphql/query/DomainGroup.gql')"
            :variables="{ fieldName: Constants.DOMAIN_SEX }"
          >
            <template v-slot="{ result: { data } }">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <label class="md-layout-item md-size-15 md-form-label">
                  Sexo
                </label>
                <div v-if="data" class="md-layout-item">
                  <md-radio
                    v-for="sex in data.getDomain"
                    :key="sex.id"
                    v-model="capDomainSex"
                    :value="sex.id"
                    >{{ sex.value }}</md-radio
                  >
                </div>
              </div>
            </template>
          </ApolloQuery>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, max_value } from "vee-validate/dist/rules";
import Swal from "sweetalert2";
import Constants from "../../../constants";

extend("required", required);
extend("max_value", max_value);

export default {
  components: {
    SlideYDownTransition
  },
  props: {},
  data() {
    return {
      model: {
        firstName: "",
        secondName: "",
        firstLastName: "",
        secondLastName: "",
        birthDate: new Date(new Date().getTime() - 18 * 365 * 1000 * 3600 * 24)
      },
      disabledDates: date => {
        const day = date.getDay();
        return Constants.daysOfDifference(date, new Date()) < 18 * 365;
      },
      capDomainSex: 0,
      Constants: Constants
    };
  },
  methods: {
    toggleMultiLevel() {
      this.multiLevel = !this.multiLevel;
    },
    toggleMultiLevel2() {
      this.multiLevel2 = !this.multiLevel2;
      this.multiLevel3 = false;
    },
    toggleMultiLevel3() {
      this.multiLevel3 = !this.multiLevel3;
      this.multiLevel2 = false;
    },
    validate() {
      if (this.capDomainSex == 0) {
        Swal.fire({
          title: "¡Falta algo!",
          text: "No olvides tu sexo",
          timer: 2000,
          showConfirmButton: false
        });
      } else if (this.model.birthDate == null) {
        Swal.fire({
          title: "¡Falta algo!",
          text: "No olvides tu fecha de nacimiento",
          timer: 2000,
          showConfirmButton: false
        });
      } else
        return this.$refs.form.validate().then(res => {
          this.$emit("on-validated", res, this.model, this.capDomainSex);
          return res;
        });
    },

    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  }
};
</script>
<style></style>
